import React, { Component } from "react";
import { Tag } from "antd";
import { withRouter } from "react-router";
import qs from "qs";

class FilterByTag extends Component {
  state = { selectedTags: [] };

  componentDidMount = () => {
    const selectedTags =
      qs.parse(this.props.history.location.search, {
        ignoreQueryPrefix: true,
      }).tags || [];
    this.setState({ selectedTags });
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.UpdateSelectedTags();
    }
  }

  UpdateSelectedTags = () => {
    const selectedTags =
      qs.parse(this.props.history.location.search, {
        ignoreQueryPrefix: true,
      }).tags || [];
    this.setState({ selectedTags });
  };

  handleTag = tag => {
    const previousSearch = qs.parse(this.props.history.location.search, {
      ignoreQueryPrefix: true,
    });
    if (!previousSearch.tags) previousSearch.tags = [];
    const index = previousSearch.tags.indexOf(tag);

    if (index > -1) {
      previousSearch.tags.splice(index, 1);
    } else previousSearch.tags = [...previousSearch.tags, tag];
    const { tags } = previousSearch;
    const search = qs.stringify({ tags });
    this.props.history.push({
      search,
    });
  };

  renderTags = () => {
    const { selectedTags } = this.state;
    const { tags } = this.props;
    return (
      <div style={{ margin: "1em" }}>
        {tags.map(({ tag }) => (
          <Tag.CheckableTag
            checked={selectedTags.includes(tag)}
            onChange={() => this.handleTag(tag)}
            key={tag}
          >
            {tag}
          </Tag.CheckableTag>
        ))}
      </div>
    );
  };

  render() {
    return this.renderTags();
  }
}

export default withRouter(FilterByTag);



// WEBPACK FOOTER //
// ./src/components/gallery/FilterByTag.js